import { create } from "zustand";

const STORAGE_KEY = "sidebar-collapsed";

const readStoredState = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch (error) {
    return false;
  }
};

interface IUseSidebar {
  collapsed: boolean;
  toggleSidebar: () => void;
  /** Off-canvas drawer state, only used on mobile widths. */
  mobileOpen: boolean;
  setMobileOpen: (open: boolean) => void;
}

export const useSidebar = create<IUseSidebar>((set) => ({
  collapsed: readStoredState(),
  toggleSidebar: () =>
    set((state) => {
      const collapsed = !state.collapsed;

      try {
        localStorage.setItem(STORAGE_KEY, String(collapsed));
      } catch (error) {
        // storage unavailable — the choice just won't survive a reload
      }

      return { collapsed };
    }),
  mobileOpen: false,
  setMobileOpen: (open) => set({ mobileOpen: open }),
}));
